export default {
      id: "icon-starbanner-usage",
      viewBox: "0 0 29 40",
      url: __webpack_public_path__ + "icons.svg#icon-starbanner",
      toString: function () {
        return this.url;
      }
    }